import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { AppErrorHandler } from './error/app-error.handler';
import { TranslateLocalLoader } from './factories/translate-local-loader';
import { LoggedInGuard } from './guards/logged-in.guard';
import { NotLoggedInGuard } from './guards/not-logged-in.guard';
import { RefreshTokenService } from './services/authentication/refresh-token.service';
import { EmptyResponseInterceptor } from './services/base/interceptors/empty-response.interceptor';
import { ErrorInterceptor } from './services/base/interceptors/error.interceptor';
import { JwtInterceptor } from './services/base/interceptors/jwt.interceptor';
import { PendingInterceptor } from './services/base/interceptors/pending.interceptor';
import { RefreshTokenInterceptor } from './services/base/interceptors/refresh-token.interceptor';
import { PendingService } from './services/base/pending.service';
import { ResolverService } from './services/base/resolver.service';
import { TranslationService } from './services/translation.service';
import { ValidationService } from './services/validation/validation.service';
import { TitlesService } from './services/visual/titles.service';
import { ToasterService } from './services/visual/toaster.service';
import { AuthApiService } from './services/api/auth-api.service';
import { CustomerApiService } from './services/api/customer-api.service';
import { ErrorApiService } from './services/api/error-api.service';
import { SaleOrderApiService } from './services/api/sale-order-api.service';
import { TraderApiService } from './services/api/trader-api.service';
import { ComplementApiService } from './services/api/complement-api.service';
import { PaymentMethodApiService } from './services/api/payment-method-api.service';
import { ProductApiService } from './services/api/product-api.service';
import { UserApiService } from './services/api/user-api.service';
import { AdministratorGuard } from './guards/administrator.guard';
import { SettingApiService } from './services/api/setting-api.service';
import { BrandApiService } from './services/api/brand-api.service';
import { SaleOfferApiService } from './services/api/sale-offer-api.service';
import { CollapseService } from './services/visual/collapse.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelSpeed: 1,
  wheelPropagation: false,
  minScrollbarLength: null
};

@NgModule({
  imports: [
    HttpClientModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    PerfectScrollbarModule,
    ToastrModule.forRoot({
      autoDismiss: true,
      maxOpened: 1,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      timeOut: environment.toasterTimeout
    }),
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useClass: TranslateLocalLoader }
    })
  ],
  exports: [
    TranslateModule
  ],
  providers: [
    // Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: PendingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: EmptyResponseInterceptor, multi: true },
    // Handlers
    { provide: ErrorHandler, useClass: AppErrorHandler },
    // Perfect scroll config
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    // API Services
    AuthApiService,
    ComplementApiService,
    CustomerApiService,
    ErrorApiService,
    PaymentMethodApiService,
    ProductApiService,
    SaleOfferApiService,
    SaleOrderApiService,
    TraderApiService,
    UserApiService,
    SettingApiService,
    BrandApiService,
    // Services
    PendingService,
    RefreshTokenService,
    ResolverService,
    TitlesService,
    ToasterService,
    TranslationService,
    ValidationService,
    CollapseService,
    // Guards
    LoggedInGuard,
    NotLoggedInGuard,
    AdministratorGuard
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/core.module.ts